import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * cleanText — display-time sanitiser for user-facing strings.
 * Both the Taste (§9.G) and Impeccable craft-floor bans treat the em/en dash
 * as an AI tell. CMS/seed copy occasionally contains them, so we normalise at
 * render (non-destructive, DB untouched): " — " becomes a spaced hyphen, and any
 * stray em/en dash collapses to a regular hyphen.
 */
export function cleanText(value) {
  if (value == null) return value;
  return String(value)
    .replace(/\s*[\u2014\u2013]\s*/g, " - ")
    .replace(/\s{2,}/g, " ")
    .trim();
}
